import { useInstance } from '../../support/ioc/useInstance';
import { Device } from '../Device.ts';
import { DevSettings } from '../DevSettings.ts';

// Returns true if native app, or web with simulateNative dev setting;
// otherwise returns false
export const useIsNative = () => {

    const deviceInfo = useInstance(Device);
    const devSettings = useInstance(DevSettings);

    return devSettings.simulateNative || deviceInfo.platform !== 'web';
};
